import script from "./InformationList.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationList.vue?vue&type=script&setup=true&lang=js"

export default script